class AdaCompliance {

	constructor() {
		this.externalLinks();
		this.embeddedMedia();
	}

	embeddedMedia() {
		window.document.querySelectorAll(".wp-block-embed-youtube")
			.forEach(item => {
				item.setAttribute("role", "none");
			});
	}

	externalLinks() {
		(<NodeListOf<HTMLLinkElement>>document.querySelectorAll(`a[target="_blank"]`))
			.forEach(item => {
				let relAttr = item.rel;
				let labelAttr = item.getAttribute("aria-label");
				const relValues = ["external", "noopener", "noreferrer"];
				const labelValue = "opens in a new window";

				if (!relAttr) {
					relAttr = relValues.join(" ");
				}
				else {
					relValues.forEach(val => {
						if (relAttr.indexOf(val) === -1) {
							relAttr += " " + val;
						}
					});
				}

				if (!labelAttr || labelAttr !== item.innerText + " " + labelValue) {
					labelAttr = item.innerText + " " + labelValue;
				}

				item.setAttribute("rel", relAttr);
				item.setAttribute("aria-label", labelAttr);
			});
	}
}

export default AdaCompliance;
